import { createStore } from 'redux';
import { portfolioReducer } from './reducers';

const store = createStore(portfolioReducer);

export default store;